export const devices = {
  // We have to specify 801 so that the media query applies styles to 800px and below
  desktop: '(min-width: 801px)',
  // The exact inverse of `desktop`, for rules that are easier to write as an addition on small
  // screens than as an override on large ones. Keep the two in lockstep: useIsMobile, MobileOnly
  // and DesktopOnly all resolve against `desktop`, so a `mobile` that didn't complement it exactly
  // would render chrome and content against different breakpoints.
  mobile: '(max-width: 800px)',
  // Where two-column page layouts collapse to one. Wider than `mobile` on purpose — a pair of
  // independently-scrolling columns stops being useful well before the viewport is phone-sized.
  tablet: '(max-width: 1050px)',
};

export default devices;
